import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  Menu,
  MenuItem,
} from '@szhsin/react-menu'
import '@szhsin/react-menu/dist/index.css'
import '@szhsin/react-menu/dist/transitions/slide.css'

import {
  ISortOptions,
} from '../../../ReceivementTypes'

import {
  actions,
} from '../../../ReceivementState'
import * as S from './ReceivementSortBySelect.styles'

const sortOptions: ISortOptions[] = [
  { value: 'status', label: 'Ordenado por Status' },
  { value: 'invoice_number', label: 'Ordenado por Nr. Nota Fiscal' },
  { value: 'product_description', label: 'Ordenado por Nome do Produto' },
  { value: 'product_code', label: 'Ordenado por Cód. do Produto' },
]

const ReceivementSortBySelect = () => {
  const dispatch = useDispatch()
  const [label, setLabel] = useState(sortOptions[0].label)

  const handleSortBy = React.useCallback(
    (newOption: ISortOptions) => {
      dispatch(actions.setSortByFilter({ sortBy: newOption.value }))
      setLabel(newOption.label)
    },
    [dispatch],
  )

  return (
    <S.Container>
      <Menu menuButton={<S.Button><S.Icon/>{label}</S.Button>} transition>
        {sortOptions.map((option) => (
          <MenuItem key={option.value} onClick={() => handleSortBy(option)}>{option.label}</MenuItem>
        ))}
      </Menu>
    </S.Container>
  )
}

export { ReceivementSortBySelect }
